<div class="permission-section d-flex justify-content-center">
  <div class="d-flex flex-column align-items-center justify-content-center"> 
  <img alt="accessDenied" class="laptop-icon" src="/assets/icons/access-denied.svg">
  <h3>Access denied</h3>
  <p class="permission-text d-flex flex-column">
    <span class="text-center">You don’t have permission to access this page.</span>
    <span>Please contact<a href="mailto:care@amdocs.com"> Amdocs product support</a> for further assistance.</span>
  </div>
</div>